<template>
  <div class="card card-stand">
    <div class="image" v-if="info.logoUrl">
      <img :src="info.logoUrl" :alt="info.name" class="rounded mx-auto d-block">
    </div>
    <div class="row">
      <div class="col-md-12 text-center">
        <router-link v-if="canEdit" tag="a" class="btn btn-success" :to="{name: 'stands-edit', params: {standId: $route.params.standId}}">
          <translate>Edit</translate>
        </router-link>
      </div>
    </div>
    <div class="card-body">
      <div class="author">
        <!--<img class="avatar border-white" src="static/img/faces/face-2.jpg" alt="...">-->
        <h4 class="title text-center">{{ info.name }}</h4>
      </div>
      <nl2br v-if="info.description !== null" tag="p" :text="info.description" class="description text-justify"/>
    </div>
    <div class="card-footer">
      <hr>
      <div class="button-container text-center">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-12 ml-auto">
            <h5>{{ info.materials.length }}
              <br>
              <small><translate translate-context="Count"
                                :translate-n="info.materials.length"
                                translate-plural="Materials">Material</translate></small>
            </h5>
          </div>
          <div class="col-lg-6 col-md-6 col-12 ml-auto">
            <h5>{{ attachmentsCount }}
              <br>
              <small><translate translate-context="Count"
                                :translate-n="attachmentsCount"
                                translate-plural="Attachments">Attachment</translate></small>
            </h5>
          </div>
          <div class="col-6 ml-auto" v-if="$auth.user().isSuperuser || $root.expoStatPermissions.stands[info.id]">
            <router-link :to="{name: 'stands-persons', params: {standId: $route.params.standId}}">
              <h5>{{ info.visitCount }}
                <br>
                <small><translate translate-context="Count"
                                  :translate-n="info.visitCount"
                                  translate-plural="Visits">Visit</translate></small>
              </h5>
            </router-link>
          </div>
          <div class="col-6 ml-auto" v-if="$auth.user().isSuperuser || $root.expoStatPermissions.stands[info.id]">
            <router-link :to="{name: 'stands-persons', params: {standId: $route.params.standId}}">
              <h5>{{ info.interestedCount }}
                <br>
                <small><translate translate-context="Count"
                                  :translate-n="info.interestedCount"
                                  translate-plural="Interested">Interest</translate></small>
              </h5>
            </router-link>
          </div>
          <!--<div v-for="(info,index) in details" :class="getClasses(index)">-->
            <!--<router-link :to="{name: info.linkTo, params: {standId: $route.params.id}}" v-if="info.linkTo">-->
              <!--<h5>{{info.title}}-->
                <!--<br>-->
                <!--<small>{{info.subTitle}}</small>-->
              <!--</h5>-->
            <!--</router-link>-->
            <!--<h5 v-else>{{info.title}}-->
              <!--<br>-->
              <!--<small>{{info.subTitle}}</small>-->
            <!--</h5>-->
          <!--</div>-->
          <!--<div class="col-lg-3 col-md-6 col-6 ml-auto">-->
            <!--<h5>12-->
              <!--<br>-->
              <!--<small>Files</small>-->
            <!--</h5>-->
          <!--</div>-->
          <!--<div class="col-lg-4 col-md-6 col-6 ml-auto mr-auto">-->
            <!--<h5>2GB-->
              <!--<br>-->
              <!--<small>Used</small>-->
            <!--</h5>-->
          <!--</div>-->
          <!--<div class="col-lg-3 mr-auto">-->
            <!--<h5>24,6$-->
              <!--<br>-->
              <!--<small>Spent</small>-->
            <!--</h5>-->
          <!--</div>-->
        </div>
      </div>
    </div>
    <div class="text-center">
      <div class="row">

      </div>
    </div>
  </div>
</template>
<script>
  import Nl2br from 'vue-nl2br'
  export default {
    created () {
      this.details.push({title: this.info.materials.length, subTitle: 'Материалов'})
      this.details.push({title: this.attachmentsCount, subTitle: 'Вложений'})
      this.details.push({title: this.info.visits, subTitle: 'Просмотров', linkTo: 'stand-persons'})
    },
    computed: {
      canEdit () {
        return  this.$root.expoStatPermissions.stands[this.$route.params.standId]
      }
    },
    components: {
      Nl2br
    },
    props: {
      info: {
        type: Object,
        default: () => {
          return {
            title: '',
            description: '',
            image: '',
            materialCount: 12,
            fileCount: 20,
            visits: 520
          }
        }
      }
    },
    data () {
      return {
        details: [],
        attachmentsCount: 0
      }
    },
    watch: {
      info() {
        this.attachmentsCount = 0
        this.info.materials.forEach(material => {
          this.attachmentsCount += material.attachments.length
        })
      }
    },
    methods: {
      getClasses (index) {
        const remainder = index % 3
        if (remainder === 0) {
          return 'col-lg-3 mr-auto'
        } else if (remainder === 2) {
          return 'col-lg-4 col-md-6 col-6 ml-auto mr-auto'
        } else {
          return 'col-lg-3 col-md-6 col-6 ml-auto'
        }
      }
    }
  }

</script>
<style lang="scss">
  .card-stand .image {
    height: auto;
  }

  .card-stand h4.title {
    margin-top: 0;
  }

  .card-stand .card-footer h5 {
    font-size: 1.25em;
    margin-bottom: 0;
  }
</style>
